<div class="wrapper">
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
